import useResultPage from '@/page/result/hooks/useResultPage'
import { useTranslation } from 'react-i18next'
import { Item } from '@/ui-components/types/item'
import { getThreeMonthsAgo } from '@/utils/date-time-utils'
import Layout from '@/component/Layout/Layout'
import { LottoResultScreen } from '@/ui-components/screens/LottoResultScreen'
const ResultPage = () => {
  const { t } = useTranslation()
  const {
    onBackAction,
    optionsMenu,
    selectedGame,
    showDropdown,
    setShowDropdown,
    handleSelect,
    selectedDate,
    handleDateChange,
    renderers,
    loading,
    handleSearchQueryChange,
  } = useResultPage()

  return (
    <Layout loading={loading}>
      <LottoResultScreen
        pageHeaderProps={{
          title: t('resultPage.header'),
          onBack: onBackAction,
        }}
        countryDropdownProps={{
          items: optionsMenu as Item[],
          showDropdown: showDropdown,
          setShowDropdown: setShowDropdown,
          selectedCountry: selectedGame ?? t('resultPage.all'),
          setSelectedCountry: handleSelect,
          onSearchQueryChange: handleSearchQueryChange,
        }}
        datePickerProps={{
          selectedDate: selectedDate,
          setSelectedDate: handleDateChange,
          minDate: getThreeMonthsAgo(),
          maxDate: new Date(),
        }}
      >
        {renderers?.map((renderer, index) => (
          <div key={`renderer-${index}`}>{renderer}</div>
        ))}
      </LottoResultScreen>
    </Layout>
  )
}

export default ResultPage
